// ===== API contracts (match mezzo-service VoxRoi DTOs) =====

export interface VoxRoiConfigResponse {
  encryptedData: string;
  version: number;
  modifiedDate: string;
}

export interface VoxRoiConfigRequest {
  encryptedData: string;
  version: number;
}

export interface VoxProductCatalogItem {
  vendor: string;
  productKey: string;
  productDisplayName: string;
  transactionNames: string[];
  sortOrder: number;
}

export interface VoxRoiProductUsageItem {
  date: string;
  productKey: string;
  vendor: string;
  transactionName: string;
  reportType: string;
  successCount: number;
}

export interface VoxRoiDailyUnitCount {
  date: string;
  unitCount: number;
}

export interface VoxRoiUsageResponse {
  totalUnitCount: number;
  unitCounts: VoxRoiDailyUnitCount[];
  productUsage: VoxRoiProductUsageItem[];
}

// ===== Decrypted config (never sent to Mezzo in plaintext) =====

export const VOX_ROI_CONFIG_VERSION = 3;

export interface CostScheduleEntry {
  effectiveFrom: string;
  effectiveTo: string | null;
  cost: number;
}

export interface BeforeProviderEntry {
  ordersPerLoan: number;
  cost: number;
}

export interface VoxRoiCostConfigData {
  version: number;
  /** date-effective cost schedules per product, keyed by catalog productKey */
  costs: Record<string, CostScheduleEntry[]>;
  /** per-provider before config keyed by catalog productKey */
  beforeProviders: Record<string, BeforeProviderEntry>;
}

// ===== Client-side ROI result =====

export interface VoxRoiBeforeProvider {
  productKey: string;
  vendor: string;
  productDisplayName: string;
  ordersPerLoan: number;
  costPerOrder: number | undefined;
}

export interface VoxRoiAfterLine {
  productKey: string;
  vendor: string;
  productDisplayName: string;
  successCount: number;
  unitCost: number;
  lineTotal: number;
}

export interface CostGapWarning {
  productKey: string;
  dates: string[];
}

export interface VoxRoiResult {
  totalUnitCount: number;
  before: {
    costPerLoan: number;
    totalSpend: number;
    providerCount: number;
    providers: VoxRoiBeforeProvider[];
  };
  after: {
    totalSpend: number;
    avgCostPerLoan: number;
    lines: VoxRoiAfterLine[];
  };
  savings: {
    total: number;
    pct: number | null;
    perLoan: number;
  };
  warnings: {
    unmappedUsage: VoxRoiProductUsageItem[];
    productsMissingCost: CostGapWarning[];
  };
}
